import React from "react";

export const NoMatch = () => (
  <div className="nomatch" style={{ fontSize: "10rem", textAlign: "center" }}>
    404找不到资源
  </div>
);